import { forwardRef } from "react";
import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export interface EmptyStateProps {
  /** Leading glyph, centred in a 48px slot. */
  icon?: ReactNode;
  /** Headline — h5 treatment. */
  title: ReactNode;
  /** Supporting copy under the title. */
  description?: ReactNode;
  /** Call-to-action rendered below the copy. */
  action?: ReactNode;
  className?: string;
}

/** Centred placeholder for empty lists/screens. */
export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, action, className }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center gap-2 px-6 py-12 text-center",
          className,
        )}
      >
        {icon ? (
          <span className="flex size-12 items-center justify-center text-content-disabled">
            {icon}
          </span>
        ) : null}
        <div className="type-h5 text-content-primary">{title}</div>
        {description ? (
          <div className="type-body-md text-content-secondary">{description}</div>
        ) : null}
        {action ? <div className="mt-3">{action}</div> : null}
      </div>
    );
  },
);
EmptyState.displayName = "EmptyState";
